import React, { useEffect } from 'react';
import '../../App.css';
import './Sponsorship.css';
import Footer from '../Footer';
import { analytics, logEvent } from "./../firebase";
import { useTranslation } from "react-i18next";

const AppStore = () => {

  const { t } = useTranslation();

  useEffect(() => {
    // Funkce pro detekci iOS zařízení
    const isIOS = () => {
      return /iPhone|iPad|iPod/i.test(navigator.userAgent);
    };

    // Funkce pro detekci Android zařízení
    const isAndroid = () => {
      return /Android/i.test(navigator.userAgent);
    };

    // URL pro Apple Store a Google Play
    const appleStoreUrl = "https://apps.apple.com/cz/app/questown/id6742157352";
    const googlePlayUrl = "https://play.google.com/store/apps/details?id=cz.midnighttree.questown";
    const questownUrl = "https://www.questown.cz/"

    logEvent(analytics, "visit_qr_all");
    // Podmínka, která uživatele přesměruje na správný obchod
    if (isIOS()) {
      logEvent(analytics, "visit_qr_ios");
      window.location.href = appleStoreUrl;
    } else if (isAndroid()) {
      logEvent(analytics, "visit_qr_android");
      window.location.href = googlePlayUrl;
    } else {
      // Pokud není rozpoznán ani iOS, ani Android, můžeš uživatele ponechat na stránce nebo ukázat nějaké upozornění
      logEvent(analytics, "visit_qr_others");
      window.location.href = questownUrl;
    }
  }, []);

  return <div>{t('text.redirToStore')}</div>;
};

export default AppStore;